export const API_RATING_SETRATING = "v1/rating/";
export const API_RATING_GETCOMMENTS = "v1/rating/comments/";
export const API_RATING_DELETE = "v1/rating/";
export const API_RATING_SETRATING_POPUP = "v1/rating/popup";
